import { initApp } from '../app.js';
import { closeMenu } from './menu.js';

const SELECTOR_WRAPPER = '.js-site-wrapper';

const SELECTOR_LINK = 'a';

const CLASSNAME_LOADED = 'is-loaded';
const TIMEOUT = 400;

const replaceHtml = (currentDocument, newDocument, selector) => {
  let newContent = newDocument.querySelector(selector);

  if (newContent) {
    currentDocument.querySelector(selector).innerHTML = newContent.innerHTML;
  } else {
    throw new Error('No element found.');
  }
}

const loadContent = (html, href, onError) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const classes = doc.body.classList.value;

  try {
    replaceHtml(document, doc, SELECTOR_WRAPPER);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    addLinksEventListeners(document);
    document.body.className = classes;

    closeMenu();
    initApp();
  } catch (e) {
    onError();
  }
}

const onError = () => {
  document.body.classList.add(CLASSNAME_LOADED);
}

const navigate = (href, push = true) => {
  document.body.classList.remove(CLASSNAME_LOADED);

  setTimeout(() => {
    fetch(href)
      .then(response => response.text())
      .then(html => {
        loadContent(html, href, onError);
        push && history.pushState(null, null, href);
      })
      .catch(error => {
        window.location.href = href;
        onError();
      });
  }, TIMEOUT);
}

const onLinkClick = (e) => {
  const { currentTarget } = e;
  const href = currentTarget.getAttribute('href');

  const isInternal = href.includes(window.location.origin);
  const isAdmin = href.includes('/wp');
  const isImage = href.includes('.jpg') ||
    href.includes('.jpeg') ||
    href.includes('.png');

  if (isInternal && !isAdmin && !isImage) {
    e.preventDefault();
    navigate(href);
  }
};

const addLinksEventListeners = (element) => {
  [].forEach.call(
    element.querySelectorAll(SELECTOR_LINK),
    link => link.addEventListener('click', onLinkClick)
  );
}

const onPopState = (event) => {
  const { href } = document.location;
  const isInternal = href.includes(window.location.origin);
  isInternal && navigate(href, false);
}

const init = () => {
  addLinksEventListeners(document);
  window.addEventListener('popstate', onPopState);
}

export default {
  init
}
